export interface Region {
   code: string;
   region: string;
}

export interface OceanPort {
   code: string;
   country: string;
   ports: string[];
}

export interface Country {
   code: string;
   country: string;
   regions?: Region[];
   ports?: string[];
   postalDetails?: {
      regex?: string,
      required?: boolean,
      maxLength?: number,
      postalExample?: string
   };
}
